module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/wave-point-246aa388b9098d05cdae251297342087.png";